import AppLoader from './app-loader';

export default AppLoader;
